var React = require('react');

function NavIconsDataTables (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21 3h-18v18h18zm-11.36 11.38v-4.76h4.72v4.76zm4.72 1v4.62h-4.72v-4.66zm0-10.41v3.69h-4.72v-3.73zm-5.72 3.71h-4.64v-3.75h4.7zm0 1v4.76h-4.64v-4.82zm6.64 0h4.72v4.76h-4.7zm0-1v-3.75h4.72v3.73zm-11.28 6.66h4.68v4.66h-4.68zm11.32 4.66v-4.66h4.68v4.66z"}));
}

NavIconsDataTables.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsDataTables;

NavIconsDataTables.default = NavIconsDataTables;
